
import { useEffect } from 'react';
import { useAdvancedPageTracking } from '@/hooks/useAdvancedPageTracking';
import HeaderV4 from '@/components/landing-v4/HeaderV4';
import HeroSectionV4 from '@/components/landing-v4/HeroSectionV4';
import PainPointsSection from '@/components/landing-v4/PainPointsSection';
import WhatIsPACTSectionV4 from '@/components/landing-v4/WhatIsPACTSectionV4';
import FeaturesSectionV4 from '@/components/landing-v4/FeaturesSectionV4';
import FinalCTASection from '@/components/landing-v4/FinalCTASection';
import FloatingCTA from '@/components/landing-v4/FloatingCTA';
import FooterV4 from '@/components/landing-v4/FooterV4';

const LandingPageV4 = () => {
  // Track page analytics with enhanced tracking
  useAdvancedPageTracking('Landing Page V4');

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-500 via-purple-400 to-indigo-500">
      {/* Header with Logo */}
      <HeaderV4 />
      
      {/* Floating CTA Button */}
      <FloatingCTA />
      
      {/* Hero Section */}
      <div className="pt-20">
        <HeroSectionV4 />
      </div>
      
      {/* Pain Points Section */}
      <PainPointsSection />
      
      {/* What is PACT Section */}
      <WhatIsPACTSectionV4 />
      
      {/* Features Section */}
      <FeaturesSectionV4 />
      
      {/* Final CTA Section */}
      <FinalCTASection />
      
      {/* Footer */}
      <FooterV4 />
    </div>
  );
};

export default LandingPageV4;
